import { CarouselPasswordIcon } from '../../assets/icons'

const IconColor = 'var(--color-blue);'

export const carouselData = [
  {
    icon: CarouselPasswordIcon,
    text: 'Markdown',
    iconHoverColor: IconColor,
  },
  {
    icon: CarouselPasswordIcon,
    text: 'Rich text documents',
    iconHoverColor: IconColor,
  },
  {
    icon: CarouselPasswordIcon,
    text: 'Budgets and personal finance',
    iconHoverColor: IconColor,
  },
  {
    icon: CarouselPasswordIcon,
    text: 'Tasks and todos',
    iconHoverColor: IconColor,
  },
  {
    icon: CarouselPasswordIcon,
    text: 'Code snippets',
    iconHoverColor: IconColor,
  },
  {
    icon: CarouselPasswordIcon,
    text: 'Passwords and keys',
    iconHoverColor: IconColor,
  },
  {
    icon: CarouselPasswordIcon,
    text: 'Outlining and lists',
    iconHoverColor: IconColor,
  },
  {
    icon: CarouselPasswordIcon,
    text: 'Family records and documents',
    iconHoverColor: IconColor,
  },
  {
    icon: CarouselPasswordIcon,
    text: 'Health records',
    iconHoverColor: IconColor,
  },
  {
    icon: CarouselPasswordIcon,
    text: 'Journaling and diary',
    iconHoverColor: IconColor,
  },
  {
    icon: CarouselPasswordIcon,
    text: 'Secure file storage',
    iconHoverColor: IconColor,
  },
  {
    icon: CarouselPasswordIcon,
    text: 'Passport and ID photos',
    iconHoverColor: IconColor,
  },
  {
    icon: CarouselPasswordIcon,
    text: 'Bank account and credit card numbers',
    iconHoverColor: IconColor,
  },
  {
    icon: CarouselPasswordIcon,
    text: 'Legal contracts and agreements',
    iconHoverColor: IconColor,
  },
  {
    icon: CarouselPasswordIcon,
    text: 'Confidential business contracts and agreements',
    iconHoverColor: IconColor,
  },
  {
    icon: CarouselPasswordIcon,
    text: 'Sensual photos and videos',
    iconHoverColor: IconColor,
  },
]
